const topbar = {
    docs: 'Documentazione',
    help: 'Aiuto',
    subscription: 'Abbonamento',
};
export default Object.freeze(topbar);
